import React, { useContext } from 'react';
import { Header, Card, Button } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../atoms/Image';
import MarkdownField from '../../../../../../components/MarkdownContent';
import { GatsbyImagePropType, MenuItemVariationPropType } from '../../../../../../services/proptypes';
import { MenuContext, FoodMenuCartContext } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import { ModifierSetsBasic } from '../../modifiers';
import ItemInteraction from '../ItemInteraction';
import ItemVariations from '../ItemVariations';
import './ItemVerticalCard.css';
var defaultProps = {
  description: null,
  image: null,
  imageAltText: '',
  imageWidth: 500,
  className: '',
  variations: [],
  gatsbyImage: {}
};
export default function ItemVerticalCard(_ref) {
  var id = _ref.id,
    name = _ref.name,
    description = _ref.description,
    image = _ref.image,
    imageAltText = _ref.imageAltText,
    gatsbyImage = _ref.gatsbyImage,
    imageWidth = _ref.imageWidth,
    onClick = _ref.onClick,
    className = _ref.className,
    variations = _ref.variations;
  var _useContext = useContext(MenuContext),
    items = _useContext.items,
    modifierSets = _useContext.modifierSets,
    disableModifiers = _useContext.disableModifiers,
    disableDescription = _useContext.disableDescription,
    precision = _useContext.precision,
    displayZeroCostItemPrices = _useContext.displayZeroCostItemPrices,
    displayZeroCostModifierPrices = _useContext.displayZeroCostModifierPrices;
  var cart = useContext(FoodMenuCartContext);
  var item = MenuUtil.getItemById(items, id);
  var itemModifierSetIds = item.modifierSets;
  var itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);
  return /*#__PURE__*/React.createElement(Card, {
    className: "item-vertical-card ".concat(className),
    onClick: onClick
  }, (!_isEmpty(image) || !_isEmpty(gatsbyImage)) && /*#__PURE__*/React.createElement(Image, {
    src: gatsbyImage && gatsbyImage.childImageSharp || "".concat(image, "?width=").concat(imageWidth),
    className: "item-horizontal-card-image",
    altText: imageAltText
  }), /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "header-container"
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "header-text"
  }, name), /*#__PURE__*/React.createElement(ItemInteraction, {
    item: item
  })), /*#__PURE__*/React.createElement(ItemVariations, {
    variations: variations,
    precision: precision,
    displayZeroCostItemPrices: displayZeroCostItemPrices
  })), !disableDescription && !_isEmpty(description) && /*#__PURE__*/React.createElement(Card.Description, null, /*#__PURE__*/React.createElement(MarkdownField, {
    className: "markdown"
  }, description)), !disableModifiers && /*#__PURE__*/React.createElement(ModifierSetsBasic, {
    modifierSets: itemModifierSets,
    displayZeroCostModifierPrices: displayZeroCostModifierPrices
  })), cart && /*#__PURE__*/React.createElement(Card.Content, {
    extra: true
  }, /*#__PURE__*/React.createElement(Button, {
    primary: true
  }, "Add To Cart")));
}
ItemVerticalCard.defaultProps = defaultProps;